import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/sand',
    },
    {
      path: '/sand',
      name: 'sand',
      component: () => import(/* webpackChunkName: "home" */ '../pages/index/sand'),
      meta: {
        title: '全景鸟瞰',
        keepAlive: false, // 需要被缓存
      },
    },
    {
      path: '/position',
      name: 'position',
      component: () => import(/* webpackChunkName: "home" */ '../pages/index/position'),
      meta: {
        title: '区域配套',
        keepAlive: false, // 需要被缓存
      },
    },
    {
      path: '/brand',
      name: 'brand',
      component: () => import(/* webpackChunkName: "home" */ '../pages/index/brand'),
      meta: {
        title: '品牌力量',
        keepAlive: false, // 需要被缓存
      },
    },
    {
      path: '/project',
      name: 'project',
      component: () => import(/* webpackChunkName: "home" */ '../pages/index/project'),
      meta: {
        title: '项目解析',
        keepAlive: false, // 需要被缓存
      },
    },
    {
      path: '/house',
      name: 'house',
      component: () => import(/* webpackChunkName: "home" */ '../pages/index/house'),
      meta: {
        title: '户型鉴赏',
        keepAlive: false, // 需要被缓存
      },
    },
    {
      path: '/house_tour',
      title: '户型漫游',
      component: () => import(/* webpackChunkName: "home" */ '../pages/index/house/index'),
      children: [
        {
          path: '',
          redirect: '01',
        },
        {
          path: '01',
          name: 'house_tour',
          component: () => import(/* webpackChunkName: "home" */ '../pages/index/house/01'),
          meta: {
            title: '室内全景',
            keepAlive: false, // 需要被缓存
          },
        },
        {
          path: '02',
          name: 'house_tour',
          component: () => import(/* webpackChunkName: "home" */ '../pages/index/house/02'),
          meta: {
            title: '室内全景',
            keepAlive: false, // 需要被缓存
          },
        },
        {
          path: '03',
          name: 'house_tour',
          component: () => import(/* webpackChunkName: "home" */ '../pages/index/house/03'),
          meta: {
            title: '室内全景',
            keepAlive: false, // 需要被缓存
          },
        },
      ],
    },
    {
      path: '/park_p',
      name: 'park_p',
      component: () => import(/* webpackChunkName: "home" */ '../pages/index/park'),
      meta: {
        title: '园林漫游',
        keepAlive: false, // 需要被缓存
      },
    },
    {
      path: '/park',
      name: 'park',
      component: () => import(/* webpackChunkName: "home" */ '../pages/index/park_t'),
      meta: {
        title: '园林点位',
        keepAlive: false, // 需要被缓存
      },
    },
    {
      path: '/book',
      name: 'book',
      component: () => import(/* webpackChunkName: "home" */ '../pages/index/book'),
      meta: {
        title: '电子楼书',
        keepAlive: false, // 需要被缓存
      },
    },
  ],
});
